/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Zone_AnaerobicInputs */

const en_ui_zone_anaerobic = /** @type {(inputs: Ui_Zone_AnaerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anaerobic`)
};

const de_ui_zone_anaerobic = /** @type {(inputs: Ui_Zone_AnaerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anaerob`)
};

/**
* | output |
* | --- |
* | "Anaerobic" |
*
* @param {Ui_Zone_AnaerobicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_zone_anaerobic = /** @type {((inputs?: Ui_Zone_AnaerobicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Zone_AnaerobicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_zone_anaerobic(inputs)
	return de_ui_zone_anaerobic(inputs)
});